// src/store/thunks/administrators/toggleAdminActiveThunk.ts
import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';
import { withLoader, withErrorHandling } from '@/store/thunks/thunkWrappers';
import type { AdminStatus } from '@/types/organization.types';

export const toggleAdminActiveThunk = createAdminAsyncThunk<
  undefined,
  { id: string; currentStatus: AdminStatus  }
>(
  'administrators/toggleActive',
  withLoader(
    withErrorHandling(
      async({ id, currentStatus }, { extra: { administratorsService } }) => {
        const newStatus: AdminStatus = currentStatus === 'Active' ? 'Inactive' : 'Active';
        await administratorsService.toggleActive(id, newStatus);
        return undefined;
      }
    )
  )
);
